import { filter } from 'rxjs/operators';
import { MonoTypeOperatorFunction, OperatorFunction } from 'rxjs';

/**
 * ignores undefined emitted values
 */
export function ignoreUndefined<T, S extends T>(): OperatorFunction<T, S>;
export function ignoreUndefined<T>(): MonoTypeOperatorFunction<T>;
export function ignoreUndefined<T>(): MonoTypeOperatorFunction<T> {
  return filter(val => val !== undefined);
}

export function ignoreNullAndUndefined<T, S extends T>(): OperatorFunction<T, S>;
export function ignoreNullAndUndefined<T>(): MonoTypeOperatorFunction<T>;
export function ignoreNullAndUndefined<T>(): MonoTypeOperatorFunction<T> {
  return filter(val => val !== undefined && val !== null);
}
